import {
  fontSize,
  primaryColor,
  borderSubtleColor,
  textMutedColor,
} from '../material-dashboard-react';

const Modal = () => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    overflow: 'auto',
  },
  modalContent: {
    width: '100%',
    maxWidth: 480,
    outline: 'none',
    animation: 'premiumFadeIn 0.28s ease-out both',
  },
  modal_wide: {
    maxWidth: 720,
  },
  modalCard: {
    margin: '0 !important',
    overflow: 'visible !important',
    borderRadius: '16px !important',
    border: `1px solid ${borderSubtleColor}`,
    boxShadow: '0 12px 40px rgba(31, 42, 50, 0.18)',
  },
  modalContainer: {
    padding: '8px 32px 28px !important',
    overflow: 'visible',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
    marginTop: 28,
    paddingTop: 20,
    borderTop: `1px solid ${borderSubtleColor}`,
  },
  modalHeader: {
    borderBottom: `1px solid ${borderSubtleColor}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '20px 32px 16px',
    marginBottom: 0,
    '& > p:first-of-type': {
      margin: 0,
    },
  },
  modalSubtitle: {
    margin: '4px 0 0',
    fontSize: fontSize.m,
    color: textMutedColor,
    fontWeight: 400,
    lineHeight: 1.5,
  },
  rejectSelectWrap: {
    width: '100%',
    position: 'relative',
    zIndex: 1,
  },
  mContainer: {
    backgroundColor: '#fff',
    width: '100%',
    padding: '24px 32px 28px',
    maxHeight: '70vh',
    overflow: 'auto',
    borderRadius: 16,
    border: `1px solid ${borderSubtleColor}`,
    boxShadow: '0 12px 40px rgba(31, 42, 50, 0.18)',
  },
  mHeader: {
    borderBottom: 'solid #e0e0e0 1px',
    alignItems: 'center',
    paddingBottom: 20,
    '& p': {
      margin: 0,
    },
  },
  mTitle: {
    fontSize: fontSize.xxl,
    color: primaryColor,
    fontWeight: '500',
  },
  mSection: {
    margin: '25px 0',
  },
  mLabel: {
    display: 'block',
    color: '#6B7780',
    fontSize: fontSize.m,
    marginBottom: 10,
    fontWeight: 500,
  },
  mMainInput: {
    fontSize: fontSize.m,
    display: 'flex',
    width: '98%',
    border: 'solid 1px #979797',
    borderRadius: 7,
    height: 52,
    padding: '0 10px',
  },
  mSubInput: {
    fontSize: fontSize.m,
    width: '75%',
    border: 'solid 1px #cecece',
    borderRadius: 7,
    height: 40,
    marginBottom: 10,
    padding: '0 10px',
  },
  mSelect: {
    width: '80%',
  },
  mDeleteIcon: {
    fontSize: fontSize.l,
    color: 'red',
    marginRight: 10,
    border: 'none',
    padding: '0px 10px',
    cursor: 'pointer',
  },
  mFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export default Modal;
